import { Field, getIn, useFormikContext } from "formik";
import { VehiclePreparationType } from "../../../../../types/vehicle.type";
import { CheckboxField, InfoField } from "./CheckboxField";
import { PreparationItem } from "./PreparationItem"; // Importe o novo componente
import { useEffect, useState } from "react";
import { getPreparators } from "@/common/services/employee.api";
import { IEmployee } from "@/types/employee.type";
type Props = {
  vehicleId: string;
  isReadOnly?: boolean;
};
export default function PreparationVehicleCheck({
  vehicleId,
  isReadOnly = false,
}: Props) {
  const { values, setFieldValue } = useFormikContext();

  const [preparators, setPreparators] = useState<IEmployee[]>([]);
  const pathToUpload = `vehicles/${vehicleId}/preparation`;
  const preparationValues: VehiclePreparationType = getIn(
    values,
    "vehiclePreparing"
  );

  useEffect(() => {
    async function loadPreparators() {
      const { ok, data } = await getPreparators();
      if (ok && data) {
        setPreparators(data);
      }
    }
    loadPreparators();
  }, []);

  return (
    <div className="w-full">
      <div className="mb-4">
        <label
          htmlFor="preparator"
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Preparador Responsável
        </label>
        <Field
          as="select"
          id="preparator"
          disabled={isReadOnly}
          name="vehiclePreparing.preparator"
          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
        >
          <option value="">Selecione um preparador...</option>
          {preparators.map((employee) => (
            <option key={employee._id} value={employee.name}>
              {employee.name}
            </option>
          ))}
        </Field>
      </div>

      <hr className="my-4" />
      <PreparationItem
        name="paintingProtection"
        label="Proteção de pintura (PP):"
        pathToUpload={pathToUpload}
        isReadOnly={isReadOnly}
      />
      <PreparationItem
        name="tracker"
        label="Rastreador (RT):"
        className="bg-gray/25"
        pathToUpload={pathToUpload}
        isReadOnly={isReadOnly}
      />
      <PreparationItem
        name="cellphoneSupport"
        label="Suporte de telefone (SC):"
        pathToUpload={pathToUpload}
        isReadOnly={isReadOnly}
      />
      <PreparationItem
        name="phoneChargerSupport"
        label="Carregador de celular (CC):"
        className="bg-gray/25"
        pathToUpload={pathToUpload}
        isReadOnly={isReadOnly}
      />
      <PreparationItem
        name="engineProtection"
        label="Proteção da carenagem (PC):"
        pathToUpload={pathToUpload}
        isReadOnly={isReadOnly}
      />
      <CheckboxField
        name="vehiclePreparing.hasSpareKey"
        label="Possui chave Reserva (CR):"
        checked={preparationValues.hasSpareKey}
        disabled={isReadOnly}
        onChange={() => {
          setFieldValue(
            "vehiclePreparing.hasSpareKey",
            !preparationValues.hasSpareKey
          );
        }}
      />
      <InfoField
        name="vehiclePreparing.trackerValidation"
        className="bg-gray/25"
        label="Validação de rastreador (VR):"
        checked={preparationValues.trackerValidation}
      />
      <InfoField
        name="vehiclePreparing.crlvDocument"
        label="CRLV (CV):"
        checked={preparationValues.crlvDocument}
      />
      <InfoField
        name="vehiclePreparing.nfDocument"
        className="bg-gray/25"
        label="Nota Fiscal (NF):"
        checked={preparationValues.nfDocument}
      />
    </div>
  );
}
